<template>
    <div>
        <div class="container pb-5">
            <!-- Placeholder -->
            <div v-if="!isPostLoaded">
                <div class="placeholder">
                    <div class="post-cover"></div>

                    <!-- Title -->
                    <div class="row justify-content-center">
                        <div class="col-12 col-lg-10">
                            <div class="page-title mt-4 mt-lg-5 mb-3"></div>
                        </div>
                        <div class="col-12 col-lg-10">
                            <div class="row">
                                <div class="col">
                                    <div class="paragraph" style="width: 35%;"></div>
                                    <div class="paragraph" style="width: 45%;"></div>
                                </div>
                                <div class="col d-flex justify-content-end align-items-center">
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Content -->
                    <div class="row justify-content-center justify-content-lg-end mt-5">
                        <div class="col-12 col-md-10 col-lg-8">
                            <div class="paragraph mb-3" style="width: 100%;"></div>
                            <div class="paragraph mb-3" style="width: 100%;"></div>
                            <div class="paragraph" style="width: 80%;"></div>
                        </div>
                        <div class="col-12 col-md-3"></div>
                    </div>
                </div>
                <!-- /.placeholder -->
            </div>
            <!-- /Placeholder -->
            <div class="mt-4" v-else>
                <!-- Title -->
                <div class="row justify-content-center">
                    <div class="col-12 col-lg-10">
                        <h1 class="page-title mb-3" v-html="post.title.rendered"></h1>
                    </div>
                    <div class="col d-flex justify-content-end align-items-center">
                        <social-sharing :url="post.link"
                            :title="post.title.rendered"
                            :description="post.excerpt.rendered"
                            inline-template
                            network-tag="a"
                        >
                            <ul class="nav social-share">
                              <li>
                                <network network="facebook">
                                    <span class="icon facebook">Facebook</span>
                                </network>
                              </li>
                              <li>
                                <network network="twitter">
                                    <span class="ml-4 icon twitter">Twitter</span>
                                </network>
                              </li>
                            </ul>
                        </social-sharing>
                    </div>
                </div>

                <div class="row mb-4">
                  <div class="col-12">
                    <p class="m-0" v-html="`${$t('message.by')} ${post._embedded.author[0].name}`" v-if="post._embedded.author[0]"></p>
                    <p class="m-0 text-black-50" v-html="dateFormat(post.date)"></p>
                  </div>
                </div>

                <!-- Content -->
                <div class="row justify-content-center justify-content-lg-end">
                    <div class="col-12 col-lg-11">
                        <div class="separate"></div>
                    </div>
                    <div class="col-12"></div>
                    <div class="col-12 col-md-10 col-lg-8">
                        <div class="post-cover" v-if="post._embedded" v-lazy-container="{ selector: 'img' }">
                          <img :data-src="post._embedded['wp:featuredmedia'][0].media_details.sizes.full.source_url" :data-srcset="`${post._embedded['wp:featuredmedia'][0].media_details.sizes.full.source_url} 2x`" :alt="post._embedded['wp:featuredmedia'][0].alt_text" class="img-fluid w-100">
                        </div>
                        <!-- /.post-cover -->
                        <div class="page-content" v-html="post.content.rendered"></div>
                    </div>
                    <div class="col-12 col-md-3 d-none d-lg-block">
                        <div class="recent-event" v-if="isMostPopularPostsLoaded">
                            <h1 class="text-uppercase text-center" v-html="$t('message.popularposts')"></h1>
                            <ul class="recent-post">
                                <li v-for="(item, key) in popularPosts" :key="key">
                                    <router-link :to="{ name: 'BlogDetail', params: { slug: decodeURIComponent(item.slug) } }">
                                        <p class="post-schedule" v-html="dateFormat(item.date)"></p>
                                        <p class="post-title" v-html="item.title.rendered"></p>
                                    </router-link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>

                <hr class="my-5">

                <div v-if="!isRelatedPostsLoaded">
                  <div class="col-12 col-md-6 col-lg-4 placeholder" v-for="index in 3" :key="index">
                    <div class="blog-article">
                      <div class="thumbnail mb-3"></div>
                      <div class="paragraph mb-4" style="width: 30%;"></div>
                      <div class="paragraph mb-2" style="width: 100%;"></div>
                      <div class="paragraph" style="width: 80%;"></div>
                    </div>
                  </div>
                </div>
                <div v-else>
                  <h2 class="title text-center" v-html="$t('message.relatedarticles')"></h2>
                  <div class="row my-3">
                    <div class="col-12 col-md-6 col-lg-4" v-for="(item, key) in relatedPosts" :key="key">
                      <router-link :to="{ name: 'BlogDetail', params: { slug: decodeURIComponent(item.slug) } }">
                        <div class="blog-article">
                          <div class="thumbnail">
                            <div class="thumbnail-media" v-lazy-container="{ selector: 'img' }" v-if="item._embedded">
                              <img :data-src="`${item._embedded['wp:featuredmedia'][0].media_details.sizes['post-thumbnail'].source_url}`" :data-srcset="`${item._embedded['wp:featuredmedia'][0].media_details.sizes.full.source_url} 2x`" class="d-block m-auto" />
                            </div>
                            <!-- /.thumbnail-media -->
                          </div>
                          <!-- /.thumbnail -->
                          <div class="blog-desc">
                            <div class="category" v-html="categoryName"></div>
                            <div class="description" v-html="item.title.rendered"></div>
                          </div>
                          <!-- /.blog-desc -->
                        </div>
                        <!-- /.blog-article -->
                      </router-link>
                    </div>
                  </div>
                  <!-- /.row -->
                </div>
            </div>
        </div>
        <!-- /.container -->
    </div>
</template>

<script>
import axios from 'axios'
import dayjs from 'dayjs'
import 'dayjs/locale/th'
import JQuery from 'jquery'
const Flickity = require('flickity')
export default {
  name: 'BlogDetail',
  data () {
    return {
      title: process.env.VUE_APP_TITLE,
      api_path: process.env.VUE_APP_API_PATH,
      post: [],
      isPostLoaded: false,
      popularPosts: [],
      isMostPopularPostsLoaded: false,
      isRelatedPostsLoaded: false,
      relatedPosts: [],
      categoryName: ''
    }
  },
  mounted () {
    this.getPost()
  },
  methods: {
    getPost () {
      const slug = this.$route.params.slug
      const lang = this.$route.params.lang
      const $vm = this
      $vm.isPostLoaded = false
      axios.get(`${this.api_path}wp-json/wp/v2/posts/`, {
        params: {
          _embed: true,
          slug: encodeURIComponent(slug),
          lang
        }
      })
        .then(async res => {
          if (res.data) {
            $vm.post = res.data[0]
            const popular = await $vm.getMostPopularPosts($vm.post.categories[0])
            $vm.popularPosts = popular.data
            $vm.isMostPopularPostsLoaded = true
            document.title = `${$vm.post.title.rendered} - ${$vm.title}`
            const $ = JQuery
            setTimeout(() => {
              if ($('.has-carousel')) {
                $('.has-carousel').each(function (i) {
                  var options = JSON.parse($(this).attr('data-flickity'))
                  const carousel = new Flickity($('.has-carousel')[i], options)
                  if (carousel) {}
                })
              }
            }, 100)
            $vm.isPostLoaded = true

            axios.get(`${this.api_path}wp-json/xilda/v1/views/${$vm.post.id}`)
              .then(() => {
                console.log('Counted!')
              })
            const related = await $vm.getRelatedPosts($vm.post.id, $vm.post.categories[0])
            if (related.data) {
              $vm.relatedPosts = related.data
              const category = await $vm.getCategoryName($vm.post.categories[0])
              if (category.data) {
                $vm.categoryName = category.data.name
              }
              $vm.isRelatedPostsLoaded = true
            }
          }
        })
    },
    async getCategoryName (catId) {
      const $vm = this
      const lang = $vm.$route.params.lang
      const category = await axios.get(`${this.api_path}wp-json/wp/v2/categories/${catId}`, {
        params: {
          lang
        }
      })
      return category
    },
    async getMostPopularPosts (categories) {
      const lang = this.$route.params.lang
      const popular = await axios.get(`${this.api_path}wp-json/wp/v2/posts`, {
        params: {
          categories,
          orderby: 'views',
          order: 'desc',
          lang,
          per_page: 5
        }
      })
      return popular
    },
    async getRelatedPosts (postId, categories) {
      const lang = this.$route.params.lang
      const related = await axios.get(`${this.api_path}wp-json/wp/v2/posts`, {
        params: {
          _embed: true,
          categories,
          lang,
          per_page: 3,
          exclude: postId
        }
      })
      return related
    },
    dateFormat (date, format = 'D MMMM YYYY') {
      const lang = this.$route.params.lang
      return dayjs(date).locale(lang).format(format)
    }
  },
  watch: {
    '$route' () {
      this.getPost()
    }
  }
}
</script>

<style lang="sass" scoped>
.post-cover
  margin-bottom: 1rem
</style>
